import getHelper from '../../../services/getHelper';

export default getHelper('/candidates/:id', {
  matchDeclaration: getHelper('/match-declarations'),
});
